window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;

export class Waveform {
  constructor({ media, callback }) {
    this.audioContext = new AudioContext();
    this.media = media;
    this.currentBuffer = null;
    this.loadAudio(callback);
  }

  // Calculate the average amplitude (in dB) for an array of samples
  dB(audioBuffer) {
    const length = audioBuffer.length;
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += audioBuffer[i] * audioBuffer[i];
    }
    const rms = Math.sqrt(sum / length);
    /* const db = 20 * (Math.log(rms) / Math.LN10); */
    return rms;
  }

  // Creates an array of item representing the average amplitudes (in dB) for the supplied `audioBuffer`
  // Each item is a chunk of `t` seconds long
  sliceAudioBuffer(audioBuffer, t) {
    // const channels = audioBuffer.numberOfChannels;
    const accuracy = 0.25;
    const length = audioBuffer.length * accuracy;
    const eachBlock = Math.round(audioBuffer.length / length);
    const samples = this.audioContext.sampleRate * t * accuracy;
    const output = [];
    let amplitude;
    // loop by chunks of `t` seconds
    for (let i = 0; i < length; i += samples) {
      const values = [];
      // loop through each sample in the chunk
      for (let j = 0; j < samples && j + i < length; j++) {
        amplitude = 0;
        /* // sum the samples across all channels
        for (let k = 0; k < channels; k++) {
          amplitude += audioBuffer.getChannelData(k)[i + j];
        } */
        const audioBuffKey = Math.round(eachBlock * (i + j));
        // sum of the left channel only
        amplitude += audioBuffer.getChannelData(0)[audioBuffKey];
        values.push(amplitude);
      }
      output.push(this.dB(values));
    }
    return output;
  }

  detectSilence(sensitivity, callback) {
    if (!this.currentBuffer) return;

    const data = this.sliceAudioBuffer(this.currentBuffer, 0.1);
    // loop on each seconds

    const result = [];

    for (let i = 0; i < data.length; i++) {
      const x = i;
      while (data[i] < sensitivity) i++;
      if (i - x <= 2) continue;
      result.push({ start: x, duration: i - x });
    }

    callback(result);
  }

  drawWaveform(canvas) {
    if (!this.currentBuffer || !canvas) {
      return;
    }
    const canvasCtx = canvas.getContext('2d');
    const { width, height } = canvasCtx.canvas;
    const leftChannel = this.currentBuffer.getChannelData(0); // Float32Array describing left channel
    canvasCtx.save();
    canvasCtx.fillStyle = 'rgb(32, 32, 32)';
    canvasCtx.fillRect(0, 0, width, height);
    canvasCtx.strokeStyle = '#071807';
    canvasCtx.globalCompositeOperation = 'lighter';
    canvasCtx.translate(0, height / 2);

    // Will draw only 1 line per 2 samples to increase performance
    const drawLines = this.audioContext.sampleRate * 0.5;
    const eachBlock = Math.floor(leftChannel.length / drawLines);
    const lineGap = width / drawLines;

    canvasCtx.beginPath();
    for (let i = 0; i <= drawLines; i++) {
      const audioBuffKey = Math.floor(eachBlock * i);
      let x = i * lineGap;
      let y = (leftChannel[audioBuffKey] * height) / 2;
      canvasCtx.moveTo(x, y);
      canvasCtx.lineTo(x, y * -1);
    }
    canvasCtx.stroke();
    canvasCtx.restore();
  }

  loadAudio(callback) {
    let req = new XMLHttpRequest();
    req.open('GET', this.media, true);
    req.responseType = 'arraybuffer';
    req.onreadystatechange = () => {
      if (req.readyState === 4 && req.status === 200) {
        this.audioContext.decodeAudioData(req.response, (buffer) => {
          this.currentBuffer = buffer;
          callback();
        }, this.onDecodeError);
      } else if (req.status !== 200) {
        alert('error during the load. Wrong url or cross origin issue');
      }
    };
    req.send();
  }

  onDecodeError(err) {
    alert('error while decoding your file.');
    console.error(err);
  }
}
